"use strict";

var _createForOfIteratorHelper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uploadPlaceholder_1 = __importStar(require("../lib/uploadPlaceholder"));

var types_1 = require("../types");

var insertFiles = function insertFiles(view, event, pos, files, options) {
  var images = files.filter(function (file) {
    return /image/i.test(file.type);
  });
  if (images.length === 0) return;
  var dictionary = options.dictionary,
      uploadImage = options.uploadImage,
      onImageUploadStart = options.onImageUploadStart,
      onImageUploadStop = options.onImageUploadStop,
      onShowToast = options.onShowToast;

  if (!uploadImage) {
    console.warn("uploadImage callback must be defined to handle image uploads.");
    return;
  }

  event.preventDefault();
  if (onImageUploadStart) onImageUploadStart();
  var schema = view.state.schema;
  var complete = 0;

  var _iterator = _createForOfIteratorHelper(images),
      _step;

  try {
    var _loop = function _loop() {
      var file = _step.value;
      var id = {};
      var tr = view.state.tr;
      tr.setMeta(uploadPlaceholder_1.default, {
        add: {
          id: id,
          file: file,
          pos: pos
        }
      });
      view.dispatch(tr);
      uploadImage(file).then(function (src) {
        var pos = uploadPlaceholder_1.findPlaceholder(view.state, id);
        if (pos === null) return;
        var transaction = view.state.tr.replaceWith(pos, pos, schema.nodes.image.create({
          src: src
        })).setMeta(uploadPlaceholder_1.default, {
          remove: {
            id: id
          }
        });
        view.dispatch(transaction);
      }).catch(function (error) {
        console.error(error);
        var transaction = view.state.tr.setMeta(uploadPlaceholder_1.default, {
          remove: {
            id: id
          }
        });
        view.dispatch(transaction);

        if (onShowToast) {
          onShowToast(dictionary.imageUploadError, types_1.ToastType.Error);
        }
      }).finally(function () {
        complete++;

        if (complete === images.length) {
          if (onImageUploadStop) onImageUploadStop();
        }
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

exports.default = insertFiles;